import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiChip, { ChipProps as MuiChipProps } from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '#web-components/components/IconButton';
import styles from './Chip.styles';

const useStyles = makeStyles(styles, { name: 'Chip' });
export interface ChipProps extends MuiChipProps {
  label?: string,
}

export default function Chip({ label, ...rest }: ChipProps) {
  const classes = useStyles();
  return (
    <MuiChip
      {...rest}
      label={label}
      className={classes.chip}
      deleteIcon={(
        <IconButton
          className={classes.deleteIcon}
          aria-label="delete"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      )}
      classes={{
        label: classes.chipLabel,
        disabled: classes.disabled,
      }}
    />
  );
}
